angular.module('bmsApp.directives').directive('treatmentList', function(){

        return {
            restrict: 'E',
            templateUrl: 'ng/trugreen/job/directives/treatmentList/TreatmentList.html',
            scope: {
              treatments: '=treatmentsModel'
            },
            link: function(scope, element, attrs) {
                scope.$watch('treatments', function(treatments){

                })
            }
        }

    });
